/**
 * Created by linjianxi on 2016/10/29.
 */

export const initHqpordInto = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_into/getter.js